import { render, staticRenderFns } from "./placeCreateForm.vue?vue&type=template&id=908eb8e8&"
import script from "./placeCreateForm.vue?vue&type=script&lang=js&"
export * from "./placeCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports